<template>
    <div :class="{active: active}" class="fullScreenLoader">
        <div class="loadingCard">
            <div class="d-flex">
                <div class="loaderHolder">
                    <div class="loader"></div>
                </div>
                <!-- <span>Loading</span> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {

        }
    },
    props: {
        active: {
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_utility.scss';
@import '../../assets/scss/_variables.scss';

.fullScreenLoader {
    flex: column;
    justify-content: center;
    align-items: center;
    z-index: 100;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(193, 193, 193, 0);
    // opacity: 0;
    display: flex;
    transition: background-color ease-in-out 200ms;
    top: -100%;

    &.active{
        background-color: rgba(193, 193, 193, 0.5);
        // opacity: 1;
        // display: flex;
        top: 0;
    }

    .loadingCard{
        // width: 40rem;
        // height: 10rem;
        // background: $lightest;
        background: none;
        @extend .radius-normal;
        text-align: center;
        padding: 2rem;

        div{

            color: $darker;
            font-weight: 600;
            // font-size: 1.5rem;

            .loaderHolder{
                background: none !important;
                .loader{

                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// FullScreenLoader.vue?7d00b5d4